/* src/app/modules/portal/components/service-tickets-panel/service-tickets-panel.component.scss */
sh-table-cell sh-icon {
  display: inline;
  position: absolute;
  margin-left: 100px;
}
sh-table {
  height: initial;
}
sh-table-cell:first-child {
  border-radius: 0.5rem;
}
.ticket-indicator {
  border-left: solid;
  border-left-width: thick;
}
.ticket-indicator[color=yellow] {
  border-color: #ffd201;
}
.ticket-indicator[color=green] {
  border-color: #009a38;
}
.ticket-indicator[color=red] {
  border-color: #e7001d;
}
.ticket-indicator[color=grey] {
  border-color: #808080;
}
.empty {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}
sh-button {
  margin-left: auto;
  padding: 10px 15px;
  margin-top: 1rem;
}
sh-table-row:not(:first-child) {
  margin-bottom: 3px;
}
sh-table-cell {
  align-items: baseline;
}
sh-table-cell span {
  margin-top: -5px;
}
/*# sourceMappingURL=service-tickets-panel.component.css.map */
